import { connect } from "react-redux";
import { LANGS } from "../../constants";
import { getShowSettings } from "../../reducers/ui/selectors";
import {
  toggleAbout,
  toggleLanguages,
  toggleLogin,
  togglePlayers,
  toggleSecret,
  toggleSettings
} from "../../reducers/ui/actions";
import { getUser, getUserAuthenticated } from "../../reducers/user/selectors";
import { destroyUserSession } from "../../reducers/user/actions";
import { getLang } from "../../reducers/crossword/selectors";
import { getMute } from "../../reducers/sound/selectors";
import { toggleMute } from "../../reducers/sound/actions";

import Settings from "./Settings";

const mapStateToProps = state => ({
  show: getShowSettings(state),
  authenticated: getUserAuthenticated(state),
  user: getUser(state),
  lang: LANGS[getLang(state)],
  mute: getMute(state)
});

const mapDispatchToProps = dispatch => ({
  hideSettings: () => dispatch(toggleSettings(false)),
  showSecret: () => dispatch(toggleSecret(true)),
  showLogin: () => dispatch(toggleLogin(true)),
  showLanguages: () => dispatch(toggleLanguages(true)),
  showPlayers: () => dispatch(togglePlayers(true)),
  signOut: () => dispatch(destroyUserSession()),
  toggleMute: () => dispatch(toggleMute()),
  showAbout: () => dispatch(toggleAbout(true))
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsContainer.js